<template>
  <div class="pt-4">
    <div class="row mb-4">
      <div class="col-12 text-center">
        <h3 class="font-weight-bolder">Our Contributors</h3>
      </div>
    </div>
    <div class="row mb-4 faq align-content-center">
      <div class="col-md-3 col-sm-4 text-center">
        <div class="card mb-30 border-0">
          <a
            target="_blank"
            class="card-img-tiles border-0"
            href="#"
            data-abc="true"
          >
            <div class="inner">
              <div class="main-img">
                <img src="../assets/img/logo.png" alt="Fasdo" />
              </div>
            </div>
          </a>
          <div class="card-body">
            <h4 class="card-title">Fasdo</h4>
            <p class="text-muted">&nbsp;</p>
            <a
              target="_blank"
              class="btn btn-fasdo-outline btn-sm"
              href="https://www.linkedin.com/in/fasdo-5728641bb/"
              data-abc="true"
              >Visit Linkedin</a
            >
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-4">
        <div class="card mb-30 border-0">
          <a
            target="_blank"
            class="card-img-tiles border-0"
            href="#"
            data-abc="true"
          >
            <div class="inner">
              <div class="main-img">
                <img
                  src="https://media-exp1.licdn.com/dms/image/C4E03AQGfG-KJ698WWA/profile-displayphoto-shrink_200_200/0/1591903358271?e=1615420800&v=beta&t=u6zaNw2BcbxzEmaX5bnzS_d4Ox1NaIB1cp1GwCgAJ-U"
                  alt="Devnandan Yadav"
                />
              </div>
            </div>
          </a>
          <div class="card-body text-center">
            <h4 class="card-title">Devnandan Yadav</h4>
            <p class="text-muted">Intern, Frontend Designer<br />(1 month)</p>
            <a
              target="_blank"
              class="btn btn-fasdo-outline btn-sm"
              href="https://www.linkedin.com/in/devnandan-yadav-2211301b0/"
              data-abc="true"
              >Visit Linkedin</a
            >
          </div>
        </div>
      </div>
    </div>
    <LoaderGif :disable="loading" :success="success" :message="message" />
  </div>
</template>

<script>
import axios from "axios";
import { domain } from "@/store/variable";
import LoaderGif from "./LoaderGif.vue";

export default {
  name: "contributors",
  components: {
    LoaderGif,
  },
};
</script>

<style scoped>
.card-img-tiles {
  display: block;
  border-bottom: 1px solid #e1e7ec;
}

.card-img-tiles > .inner {
  display: table;
  width: 100%;
}

.card-img-tiles .main-img,
.card-img-tiles .thumblist {
  display: flex;
  justify-content: center;
  padding-top: 15px;
  padding-bottom: 15px;
}

.card-img-tiles .main-img > img:last-child,
.card-img-tiles .thumblist > img:last-child {
  margin-bottom: 0;
}

.card-img-tiles .main-img > img {
  display: block;
  width: 45%;
  margin-bottom: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/contributors.vue